export default __webpack_public_path__ + "static/media/trash.fe153edc.svg";